var _style, _g, _rect, _path, _path2, _polygon, _g2, _polygon2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRgbAirmasterWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1277.44 160",
    style: {
      enableBackground: "new 0 0 1277.44 160"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E9EBED;}\n\t.st1{fill:#CF5792;}\n\t.st2{fill:#F4D1C1;}\n\t.st3{fill:#FED34C;}\n\t.st4{fill:#25384A;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#231F20;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M52.51,2.25L0,157.74h20.51l15.77-46.88c0,0,13.37,3.84,28.62,3.84c15.38,0,28.61-3.84,28.61-3.84l-5.29-15.73 c0,0-7.94,3.34-23.32,3.34c-15.24,0-23.21-3.84-23.21-3.84l30.87-91.5l52.05,154.59h20.51L92.62,2.25H52.51z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 178.11,
    y: 2.25,
    className: "st5",
    width: 19.38,
    height: 155.49
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M356.74,47.1c0-28.84-22.08-44.84-59.72-44.84h-48.23v155.49h19.38V18.48h31.1c24.12,0,36.51,9.91,36.51,28.62 c0,18.71-12.39,28.84-36.51,28.84c-12.23,0-19,3.51-19,3.51l5.09,15.19c0,0,4.94-2.47,14.81-2.47l37.18,65.58h22.31l-38.76-68.28 C343.89,83.83,356.74,69.19,356.74,47.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1238.68,89.47c22.99-5.63,35.83-20.28,35.83-42.37c0-28.85-22.09-44.84-59.72-44.84h-48.22v155.49h19.38V18.48 h31.1c24.12,0,36.51,9.91,36.51,28.62c0,18.7-12.39,28.84-36.51,28.84c-7.7,0-11.92-1.82-11.92-1.82l-5.24,15.23 c0,0,8.19,2.82,18.07,2.82l37.18,65.58h22.31L1238.68,89.47z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "481.86,156.84 441.52,2.25 402.53,2.25 402.53,157.74 421.92,157.74 421.92,3.16 461.8,157.74  501.91,157.74 541.8,3.16 541.8,157.74 561.18,157.74 561.18,2.25 522.19,2.25 "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M839.89,70.08l-20.96-4.96c-25.69-6.08-32.9-12.62-32.9-24.34c0-15.78,13.97-24.56,34.26-24.56 c23.89,0,37.85,13.75,39.66,32.22H880C877.3,21.63,857.92,0,819.39,0c-29.3,0-54.31,16.23-54.31,41.69 c0,21.63,15.33,35.38,47.78,43.04l20.95,4.96c20.06,4.73,29.3,13.07,29.3,27.49c0,16.45-16,26.59-38.98,26.59 c-23.66,0-41.47-18.48-42.81-40.79h-20.06c2.03,29.52,22.98,57.01,63.78,57.01c36.96,0,59.27-19.15,59.27-42.59 C884.29,90.37,868.74,76.85,839.89,70.08"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "898.52,18.48 950.8,18.48 950.8,157.74 970.18,157.74 970.18,18.48 1022.46,18.48 1022.46,2.25  898.52,2.25 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1065.21,86.09v-0.98c1.01-0.41,9.01-3.45,23.59-3.45c15.49,0,23.59,4.01,23.59,4.01l5.5-16.26 c0,0-13.59-4.01-29.08-4.01c-9.53,0-18.23,1.49-23.59,2.65V18.48h70.09V2.25h-89.46v155.49h91.27v-16.22h-71.89V86.09z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M646.92,2.25l-52.51,155.49h20.51l15.78-46.88c0,0,13.37,3.84,28.61,3.84c15.38,0,28.61-3.84,28.61-3.84 l-5.29-15.73c0,0-7.94,3.34-23.32,3.34c-15.24,0-23.21-3.84-23.21-3.84l30.87-91.5l52.06,154.59h20.5L687.03,2.25H646.92z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRgbAirmasterWhite);
export default __webpack_public_path__ + "static/media/RGB_Airmaster-white.869841df81968ce52e428476c87d7f4e.svg";
export { ForwardRef as ReactComponent };